import React from 'react'
import digitalimg from '../Assets/digitalimg.jpg'
import digitalimg3 from '../Assets/digitalimg3.jpg'
function Digitalmarketing() {
  return (
    <>
    <section className="bg-gradient-to-br from-[#e710ea] to-black py-10 md:py-32">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <h1 className="text-white font-bold font-serif text-4xl md:text-65l leading-tight mb-6 ">
          Digital Marketing Service's
          </h1>
          <p className="text-white text-lg md:text-2xl font-serif ">
          Bulk SMS Nagpur has extensive experience in online advertising, search engine marketing, and new media promotions.
          We utilize emerging technologies for branding and marketing, ensuring your business reaches its maximum potential online.
          </p>
        </div>
</section>
<section class="bg-zinc-50 overflow-hidden">
 <div class="max-w-screen-xl 2xl:max-w-screen-3xl px-8 md:px-12 mx-auto py-12 lg:py-24 space-y-24 xl:h-[540px] h-full flex flex-col justify-center">
  <div class="flex flex-col sm:flex-row mx-auto">
    <a href="#_"> <img src={digitalimg} class="rounded-xl  rotate-6 hover:rotate-0 duration-500 hover:-translate-y-12 h-full w-full object-cover hover:scale-130 transform origin-bottom" alt="#_"/> </a><a href="#_"> <img src={digitalimg3} class="rounded-xl  -rotate-12 hover:rotate-0 duration-500 hover:-translate-y-12 h-full w-full object-cover hover:scale-130 transform origin-bottom" alt="#_"/> </a>
  </div> 
 </div>
</section>
    
    </>
  )
}

export default Digitalmarketing